import { Component, OnInit } from '@angular/core';

import { SimpleComponent } from '../../common/simple.component';

@Component({
	selector: 'app-bank-transactions-types',
	templateUrl: './bank-transactions-types.component.html',
	styleUrls: ['./bank-transactions-types.component.css'],
})
export class BankTransactionsTypesComponent extends SimpleComponent {
	protected apiUrl = 'bankTransactionsTypes';
	elements: Array<BankTransactionsType> = [];
	data: BankTransactionsType = {
		id: null,
		name: null,
		status: 1,
	};
	tableRows = [{ id: 'name', name: 'Nazwa' }];

	protected resetData(): void {
		this.data = {
			id: null,
			name: '',
			status: 1,
		};
	}
}
export interface BankTransactionsType {
	id: number;
	name: string;
	status: number;
}
